import { redirect } from "@tanstack/solid-router";
import { createFileRoute } from "@tanstack/solid-router";

export const Route = createFileRoute("/_authed/reports/")({
  beforeLoad: () => { throw redirect({ to: "/admin" }); },
});
